// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  display: block;
}
:host ion-item-divider {
  cursor: pointer;
}
:host .list-view .main-image {
  margin-bottom: 0px;
  width: 100%;
  height: auto !important;
  max-height: unset !important;
  object-fit: cover;
  object-position: center;
}
:host .list-view .main-image.activated {
  opacity: 0.7;
}
:host .thumbnail-image {
  height: 33vw;
  max-height: 250px;
  padding: 0px 0px 0px 0px !important;
  position: relative;
}
:host .thumbnail-image img {
  height: 100%;
  width: 100%;
  object-fit: cover;
  background-position: center;
}
:host .thumbnail-image:nth-child(3n) {
  padding-right: 0px !important;
}
:host .thumbnail-image.activated {
  opacity: 0.7;
}
:host .thumbnail-image.main-image {
  height: 27vh;
}
:host .thumbnail-image.main-image.is-video .icon-play {
  height: 50px;
  width: 50px;
  top: calc(50% - 35px);
  padding: 10px 7px 10px 13px;
  left: calc(50% - 35px);
}
:host .thumbnail-image.is-video .icon-play {
  background-color: white;
  border-radius: 50%;
  height: 25px;
  width: 25px;
  top: calc(50% - 13px);
  padding: 5px 3px 5px 7px;
  left: calc(50% - 17px);
  position: absolute;
  box-shadow: 0px 0px 10px -2px var(--ion-color-dark);
  color: var(--ion-color-dark);
}

:host-context(.plt-desktop) .thumbnail-image {
  height: 160px;
}`, "",{"version":3,"sources":["webpack://./src/app/components/gallery/gallery-component.scss"],"names":[],"mappings":"AAAA;EACE,cAAA;AACF;AACE;EACE,eAAA;AACJ;AAGI;EACE,kBAAA;EACA,WAAA;EACA,uBAAA;EACA,4BAAA;EACA,iBAAA;EACA,uBAAA;AADN;AAGM;EACE,YAAA;AADR;AAME;EACE,YAAA;EACA,iBAAA;EACA,mCAAA;EACA,kBAAA;AAJJ;AAKI;EACE,YAAA;EACA,WAAA;EACA,iBAAA;EACA,2BAAA;AAHN;AAMI;EACE,6BAAA;AAJN;AAOI;EACE,YAAA;AALN;AAQI;EACE,YAAA;AANN;AAQQ;EACE,YAAA;EACA,WAAA;EACA,qBAAA;EACA,2BAAA;EACA,sBAAA;AANV;AAYM;EACE,uBAAA;EACA,kBAAA;EACA,YAAA;EACA,WAAA;EACA,qBAAA;EACA,wBAAA;EACA,sBAAA;EACA,kBAAA;EACA,mDAAA;EACA,4BAAA;AAVR;;AAiBE;EACE,aAAA;AAdJ","sourcesContent":[":host {\n  display: block;\n\n  ion-item-divider {\n    cursor: pointer;\n  }\n\n  .list-view {\n    .main-image {\n      margin-bottom: 0px;\n      width: 100%;\n      height: auto !important;\n      max-height: unset !important;\n      object-fit: cover;\n      object-position: center;\n\n      &.activated {\n        opacity: 0.7;\n      }\n    }\n  }\n\n  .thumbnail-image {\n    height: calc(33vw);\n    max-height: 250px;\n    padding: 0px 0px 0px 0px !important;\n    position: relative;\n    img {\n      height: 100%;\n      width: 100%;\n      object-fit: cover;\n      background-position: center;\n    }\n\n    &:nth-child(3n) {\n      padding-right: 0px !important;\n    }\n\n    &.activated {\n      opacity: 0.7;\n    }\n\n    &.main-image {\n      height: calc(27vh);\n      &.is-video {\n        .icon-play {\n          height: 50px;\n          width: 50px;\n          top: calc(50% - 35px);\n          padding: 10px 7px 10px 13px;\n          left: calc(50% - 35px);\n        }\n      }\n    }\n\n    &.is-video {\n      .icon-play {\n        background-color: white;\n        border-radius: 50%;\n        height: 25px;\n        width: 25px;\n        top: calc(50% - 13px);\n        padding: 5px 3px 5px 7px;\n        left: calc(50% - 17px);\n        position: absolute;\n        box-shadow: 0px 0px 10px -2px var(--ion-color-dark);\n        color: var(--ion-color-dark);\n      }\n    }\n  }\n}\n\n:host-context(.plt-desktop) {\n  .thumbnail-image {\n    height: 160px;\n    img {\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
